
import img1 from 'src/assets/images/about/activity.avif';
import img2 from "src/assets/images/services/2.avif";
import img3 from "src/assets/images/services/3.avif";
import img4 from "src/assets/images/services/4.avif";
import img5 from "src/assets/images/services/5.avif";
import img6 from "src/assets/images/services/6.avif";
import img7 from "src/assets/images/services/7.avif";
import img8 from "src/assets/images/services/8.avif";



import { isRTL } from 'src/utils/global';

export type ServiceType = {
    [key: string]: {
        title: string;
        list: string[];
    } | any;
    img: any;
    aos?: string;
    id: string;
};

const services: ServiceType[] = [
    {
        id: "engine_maintenance_0",
        ar: {
            title: "صيانة المحركات",
            list: [
                "إجراء عملية عمرة كاملة لجميع أنواع المحركات مع استخدام قطع الغيار الأصلية للحصول على أفضل أداء.",
                "فك وتركيب المحرك بدقة وربط جميع التوصيلات لضمان عمل المحرك بكفاءة.",
                "استبدال جوان رأس المحرك بما في ذلك القرسوني والتستاته وغيرها من المكونات المهمة."
            ]
        },
        en: {
            title: "Engine Maintenance",
            list: [
                "Performing a complete overhaul for all types of engines, using original spare parts for optimal performance.",
                "Removing and reinstalling engines with precision and ensuring all connections are secure for efficient operation.",
                "Replacing the engine head gasket, including components such as Gersoni and testata for smooth functionality."
            ]
        },
        img: img1,
    },
    {
        id: "gearbox_maintenance_1",
        ar: {
            title: "صيانة الكمبيوات",
            list: [
                "فك الكمبيو بعناية وتركيبه مرة أخرى لضمان سلاسة الأداء والحركة.",
                "إجراء الصيانة الدورية أو الكاملة للكمبيو لمعالجة الأعطال المحتملة."
            ]
        },
        en: {
            title: "Gearbox Maintenance",
            list: [
                "Carefully removing and reinstalling the gearbox to ensure smooth performance and mobility.",
                "Conducting regular or full maintenance of the gearbox to address any potential issues or faults."
            ]
        },
        img: img2,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "chassis_maintenance_2",
        ar: {
            title: "صيانة الصالة",
            list: [
                "فك وتركيب ماص الصدمات لتحسين استقرار السيارة وتقليل الاهتزازات أثناء القيادة.",
                "إصلاح أو استبدال علبة عجلة القيادة لضمان التحكم الدقيق والسلس في السيارة.",
                "فك وتركيب أذرع الميزان للحفاظ على توازن السيارة وتجنب التآكل غير المنتظم للإطارات."
            ]
        },
        en: {
            title: "Chassis Maintenance",
            list: [
                "Removing and installing shock absorbers to enhance vehicle stability and reduce vibrations while driving.",
                "Repairing or replacing the steering wheel box to ensure precise and smooth vehicle control.",
                "Removing and reinstalling control arms to maintain vehicle balance and prevent uneven tire wear."
            ]
        },
        img: img3,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "brake_maintenance_3",
        ar: {
            title: "صيانة الفرامل",
            list: [
                "فك وتركيب وصيانة الفرامل الأمامية والخلفية باستخدام تقنيات متقدمة لضمان السلامة.",
                "إصلاح وتركيب مضخة الفرامل مع إجراء الصيانة اللازمة لضمان الكفاءة في الأداء.",
                "استبدال موانع ترسب الزيت للحفاظ على نظام الكبح في أفضل حالة."
            ]
        },
        en: {
            title: "Brake Maintenance",
            list: [
                "Removing, installing, and maintaining front and rear brakes using advanced techniques for maximum safety.",
                "Repairing and reinstalling the brake pump with the necessary servicing to ensure effective performance.",
                "Replacing oil sediment preventers to keep the braking system in top-notch condition."
            ]
        },
        img: img4,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "air_system_maintenance_4",
        ar: {
            title: "صيانة الهواء",
            list: [
                "فك وتركيب السفيتيات بأعلى دقة لضمان كفاءة نظام الهواء.",
                "إصلاح وتركيب الصمامات المتنوعة للمحافظة على تدفق الهواء بشكل مثالي.",
                "صيانة نظام الدبلكس والعطاس لضمان استمرارية الأداء بكفاءة عالية."
            ]
        },
        en: {
            title: "Air System Maintenance",
            list: [
                "Removing and installing safety valves with utmost precision to ensure air system efficiency.",
                "Repairing and installing various valves to maintain an optimal air flow.",
                "Maintaining the duplex and clutch systems for continuous high-performance operations."
            ]
        },
        img: img5,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "hydraulic_maintenance_5",
        ar: {
            title: "صيانة الهيدروليك",
            list: [
                "تركيب منظومة هيدروليك متكاملة لتلبية احتياجات العمل بأعلى مستويات الجودة.",
                "صيانة السلات والروافع والضواغط لضمان قوة التحمل والأداء العالي للمعدات."
            ]
        },
        en: {
            title: "Hydraulic Maintenance",
            list: [
                "Installing a complete hydraulic system to meet operational needs with the highest quality standards.",
                "Maintaining baskets, lifts, and compressors to ensure durability and high equipment performance."
            ]
        },
        img: img6,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "electrical_maintenance_6",
        ar: {
            title: "صيانة الكهرباء",
            list: [
                "إصلاح الإنارة الأمامية والخلفية للسيارة لضمان رؤية واضحة وآمنة أثناء القيادة.",
                "تركيب نظام بيانتو كهربائي كامل بما يشمل الكابينة وإنارة المحرك."
            ]
        },
        en: {
            title: "Electrical Maintenance",
            list: [
                "Repairing front and rear lighting to ensure clear and safe visibility during driving.",
                "Installing a complete electrical wiring system, including cabin and engine lighting setups."
            ]
        },
        img: img7,
        aos: isRTL() ? "fade-left" : "fade-right"
    },
    {
        id: "computer_diagnostics_7",
        ar: {
            title: "كشف بالكمبيوتر",
            list: [
                "إجراء كشف شامل لجميع الأعطال باستخدام أحدث أجهزة الكمبيوتر.",
                "برمجة وحدات التحكم الإلكترونية (البكس) لضمان الأداء المثالي للنظام."
            ]
        },
        en: {
            title: "Computer Diagnostics",
            list: [
                "Performing comprehensive fault detection using the latest computer systems.",
                "Programming electronic control units (ECU) to ensure optimal system performance."
            ]
        },
        img: img8,
        aos: isRTL() ? "fade-left" : "fade-right"
    }
];

export default services;
